import { Location } from '../components/Location/Location';

export function getJobColor(location: Location): string {
    let color = '#777777';
    switch (location.getLocationType()) {
        case 'oddział krajowy':
            color = '#ffc26f';
            break;
        case 'rodzaj':
            color = '#f56c7e';
            break;
        case 'klient':
            color = '#70a0ff';
            break;
        case 'podsortownia/oddział krajowy':
            color = '#96de7e';
            break;
        case 'sortownia':
            color = '#ba71eb';
            break;
        case 'inne':
            color = '#86eaf7';
            break;
        case 'mini depot':
            color = '#86f7be';
            break;
        default:
            color = '#c7f587';
            break;
    }

    return color;
}
